<template>
    <div>
        <mq-layout class="lang-switcher" :mq="['md', 'lg', 'xl', 'hd', 'inf']">
            <div>
                <span>{{$store.state.app.locales[$i18n.locale]}}</span>
                <span v-for="(lang, key) in $store.state.app.locales" :key="key" v-if="$i18n.locale!=key" @click="changeLocale(key)">{{lang}}</span>
            </div>
        </mq-layout>
        <mq-layout class="lang-switcher-inline" :mq="['xs', 'sm', 'ms']">
            <i class="icon-language"></i> <span v-for="(lang, key) in $store.state.app.locales" :key="key" :class="{active: $i18n.locale==key}" @click="changeLocale(key)">{{lang}}</span>
        </mq-layout>
    </div>
</template>

<script>
    export default {
      data () {
        return {

        }
      },
      methods: {
        changeLocale (locale) {
          if(locale != this.$i18n.locale){
            this.changeLanguage(locale)
            this.$route.params.lang = locale
            this.$route.query.nav = true
            this.$router.push({
              name: this.$route.name,
              query: this.$route.query,
              params: this.$route.params
            })
          }
        }
      }
    }
</script>

<style lang="scss">
    .lang-switcher{
        position: relative;
        height: 30px;
        overflow: hidden;
        &>div{
            background: #fff;
        }
        &:hover{
            overflow: visible;
            &>div{
                box-shadow: 0px 2px 6px #0000001A;
            }
        }
        &:after{
            content: "";
            display: block;
            width: 6px;
            height: 6px;
            border-left: 1px solid $main-color;
            border-bottom: 1px solid $main-color;
            transform: rotate(-45deg);
            position: absolute;
            top: 8px;
            right: 10px;
        }
        span{
            display: block;
            line-height: 30px;
            padding: 0 10px;
            padding-right: 20px;
            &:hover{
                background-color: #EFF0F0;
            }
            &.active{
                font-family: $font-bold
            }
        }
    }
    .lang-switcher-inline{
        span{
            margin-right: 15px;
            &.active{
                font-family: $font-bold;
            }
        }
    }
</style>
